'use client';

export type {
  FeatureFlagAvailability,
  FeatureFlags,
} from '@/features/feature-flags/lib/feature-flags';
import {
  useFeatureFlagAvailabilityContext,
  useFeatureFlagsContext,
} from '@/next-app/client/feature-flags-provider';

export const useFeatureFlags = () => useFeatureFlagsContext();

/**
 * Whether the snapshot `useFeatureFlags` returns was actually evaluated. Read
 * it wherever a flag decides what the user is told about their organization —
 * not where it only shows or hides something (ENG-2783).
 */
export const useFeatureFlagAvailability = () =>
  useFeatureFlagAvailabilityContext();
